import React from "react";
import { ListView } from "@progress/kendo-react-listview";
import { Button } from "@progress/kendo-react-buttons";
import { PanelBar, PanelBarItem } from "@progress/kendo-react-layout";
import Cookies from "../Common/Util_methods/cookies";

type Handler = () => void;
interface SettingsProps {
    toggleVisible: Handler;
    logOut: Handler;
}

const Settings = (props: SettingsProps) => {
    const renderName = () => (
        <div className="user-name" style={{ marginBottom: "1rem" }}>
            <span style={{ fontWeight: "bold" }}>User Name:</span>{" "}
            {Cookies.get("fleet-name")}
        </div>
    );

    // Content for User Countries panel
    const renderCountriesContent = () => {
        let countries: any = Cookies.get("fleet-user-countries");
        if (!countries) {
            return null;
        }
        countries = JSON.parse(countries);
        if (countries[0] === "*") {
            countries[0] = "All";
        }

        const renderCountryItem = (props: any) => (
            <div className="k-listview-item" style={{ padding: "0.5rem 0" }}>
                {props.dataItem}
            </div>
        );

        return <ListView data={countries} item={renderCountryItem} />;
    };

    // Utility to get friendly labels for group names
    const getLabel = (label: string) => {
        switch (true) {
            case label === "fleetmanagementusers":
                return "Fleet Management";
            case label === "theboxusers":
                return "The Box";
            case label === "licenseusers":
                return "Licence View";
            case label === "academyusers":
                return "Cloud Simualator";
            case label === "filesharingusers":
                return "File Sharing";
            case label === "competencemanagementusers":
                return "Competence Management";
            default:
                return label;
        }
    };

    // Utility to get the role label from a RoleID
    const getRole = (role: number) => {
        switch (true) {
            case role < 2:
                return "Administrator";
            case role < 3:
                return "Super user";
            case role < 4:
                return "Local admin";
            case role < 5:
                return "Local user";
            // Uncomment these if you want to include Customer roles:
            case role < 6:
                return "Customer admin";
            case role < 7:
                return "Customer user";
            case role < 8:
                return "Billing user";
            case role < 9:
                return "Spareparts inspector";
            case role < 10:
                return "Demo user";
            default:
                return "Default Role";
        }
    };

    // Content for User Roles panel
    const renderUserRolesContent = () => {
        let groups: any = Cookies.get("fleet-user-groups");
        if (!groups) {
            return null;
        }
        groups = JSON.parse(groups);

        const renderGroupItem = (props: any) => {
            const GroupName = getLabel(props.dataItem.GroupName);
            const RoleID = getRole(props.dataItem.RoleID);
            return (
                <div
                    className="k-listview-item"
                    style={{
                        display: "flex",
                        padding: "10px",
                        borderBottom: "1px solid #eee"
                    }}
                >
                    <div style={{ flex: 1, fontWeight: "bold" }}>{GroupName}</div>
                    <div style={{ width: "100px", textAlign: "right" }}>{RoleID}</div>
                </div>
            );
        };

        return <ListView data={groups} item={renderGroupItem} />;
    };

    return (
        <div className="userInfo" style={{ padding: "1rem" }}>
            {renderName()}
            <PanelBar>
                <PanelBarItem title="User Countries">
                    {renderCountriesContent()}
                </PanelBarItem>
                <PanelBarItem title="User Roles">
                    <div
                        style={{
                            display: "flex",
                            fontWeight: "bold",
                            borderBottom: "2px solid #ccc",
                            padding: "0.5rem 0",
                            marginBottom: "0.5rem"
                        }}
                    >
                        <div style={{ flex: 1 }}>Group Name</div>
                        <div style={{ width: "100px", textAlign: "right" }}>Role</div>
                    </div>
                    {renderUserRolesContent()}
                </PanelBarItem>
            </PanelBar>
            <div
                className="action-bar"
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "1rem",
                    marginTop: "1rem"
                }}
            >
                <Button className="k-button" onClick={props.logOut}>
                    Log Out
                </Button>
                <Button className="k-button" onClick={props.toggleVisible}>
                    Close
                </Button>
            </div>
        </div>
    );
};

export default Settings;
